import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const FN_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/track-visit`;
const ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Fire-and-forget; edge function captures IP + geo server-side
    fetch(FN_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: ANON_KEY,
        Authorization: `Bearer ${ANON_KEY}`,
      },
      body: JSON.stringify({
        page_path: location.pathname,
        referrer: document.referrer || null,
      }),
      keepalive: true,
    }).catch(() => {});
  }, [location.pathname]);
};
